import { render, staticRenderFns } from "./PTopBadgeDescription.vue?vue&type=template&id=b75c68b0&"
import script from "./PTopBadgeDescription.vue?vue&type=script&lang=js&"
export * from "./PTopBadgeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports